module.exports = __webpack_public_path__ + "img/HRV.69383f8b.svg";